<template functional>
  <div>
    <el-tag
      :type="`${
        !props.row.hour_type
          ? 'danger'
          : props.row.hour_type.includes('Nocturna')
          ? 'secondary'
          : 'info'
      }`"
    >
      {{
        props.row.hour_type
          ? props.row.hour_type
          : $t('common_words.no_assignment')
      }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'HourTypeFormatter',
};
</script>
